import {
  Award,
  Banknote,
  Building2,
  CalendarCheck,
  CalendarClock,
  CalendarPlus,
  CalendarX,
  Check,
  Circle,
  CircleX,
  ClipboardCheck,
  ClipboardList,
  CreditCard,
  FileCheck,
  FileClock,
  FileWarning,
  Flag,
  GraduationCap,
  Mail,
  MessageCircle,
  MessageSquare,
  PauseCircle,
  Percent,
  PhoneCall,
  PhoneMissed,
  PhoneOff,
  Plane,
  PlaneTakeoff,
  Presentation,
  ReceiptText,
  Repeat,
  RotateCcw,
  Send,
  Star,
  TriangleAlert,
  Undo2,
  UserMinus,
  UserPlus,
  Users,
  X,
  type LucideIcon,
} from 'lucide-react';

/**
 * The allowlist behind `student_event_types.icon`.
 *
 * Static, and deliberately so: a dynamic `lucide-react/dist/esm/icons/${name}`
 * import would pull the whole icon set into the bundle and defeat tree-shaking
 * (CLAUDE.md, "Bundle & loading"). An institute can therefore store any string
 * it likes in that column without being able to break a render or the budget —
 * an unrecognised name falls back to a neutral dot.
 */
const ICONS: Readonly<Record<string, LucideIcon>> = Object.freeze({
  Award,
  Banknote,
  Building2,
  CalendarCheck,
  CalendarClock,
  CalendarPlus,
  CalendarX,
  Check,
  CircleX,
  ClipboardCheck,
  ClipboardList,
  CreditCard,
  FileCheck,
  FileClock,
  FileWarning,
  Flag,
  GraduationCap,
  Mail,
  MessageCircle,
  MessageSquare,
  PauseCircle,
  Percent,
  PhoneCall,
  PhoneMissed,
  PhoneOff,
  Plane,
  PlaneTakeoff,
  Presentation,
  ReceiptText,
  Repeat,
  RotateCcw,
  Send,
  Star,
  TriangleAlert,
  Undo2,
  UserMinus,
  UserPlus,
  Users,
  X,
});

/** Names a teacher may choose from when creating a custom type. */
export const ICON_CHOICES: readonly string[] = Object.freeze(Object.keys(ICONS).sort());

interface Props {
  name: string | null;
  size?: number;
  className?: string;
}

export function EventIcon({ name, size = 15, className }: Props): JSX.Element {
  const Icon =
    name !== null && Object.prototype.hasOwnProperty.call(ICONS, name)
      ? // eslint-disable-next-line security/detect-object-injection -- guarded by hasOwnProperty against a frozen own-keys-only map, so a crafted name cannot reach Object.prototype
        (ICONS[name] ?? Circle)
      : Circle;
  return <Icon size={size} className={className} aria-hidden="true" />;
}
